module.exports = __webpack_public_path__ + "media/img/features/secret-url-languages-large-e70c69ef87d56cec91a1ad3eb5ac2bd2.png";